import React, { useContext } from "react";
import { useState } from "react";
import "../../css_files/Master/AddUnitMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";

function AddUnitMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  unitupdatedata,
}) {
  const [unitData, setUnitData] = useState({
    Name: triggerupdate ? unitupdatedata?.name : "",
    Code: triggerupdate ? unitupdatedata?.code : "",
    Description: triggerupdate ? unitupdatedata?.description : "",
  });
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const { setExpiredSession } = useContext(triggerscroll);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/Unit/UpdateUnit`;
      axiosInstance
        .post(url, {
          unitID: unitupdatedata.id,
          code: unitData.Code,
          name: unitData.Name,
          description: unitData.Description,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((err) => {
          if (err.status === 500)
            Swal.fire({
              title: "Errors Occured",
              text: err.response.data.error,
              icon: "error",
            });
          else
            toast.error("Failed to Update", {
              position: "bottom-center",
              theme: "dark",
            });

          console.log(err);
          setloading(false);
        });
    } else {
      const URL = `${process.env.REACT_APP_API_URL}/api/v1/Unit`;
      axiosInstance
        .post(URL, unitData)
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.error("Error adding packing data:", error);
          if (error.status === 500)
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          else
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });

          setloading(false);
        });
    }
  }
  return (
    <form className="add-unit-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Unit Name{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Unit Name"
          value={unitData.Name}
          onChange={(e) => setUnitData({ ...unitData, Name: e.target.value })}
          onInput={(e) => {
            e.target.value = e.target.value
              .replace(/[^a-zA-Z\s]/g, "")
              .slice(0, 100);
            axiosInstance
              .get(
                `${process.env.REACT_APP_API_URL}/api/v1/Unit/GetUnitByIdOrNameOrCode?name=${e.target.value}`
              )
              .then(() => setMessage("Unit Already Exists With This Name"))
              .catch((error) => {
                setMessage("");
              });
          }}
          required
        />
        <span style={{ color: "red" }}>{message}</span>
      </blockquote>
      <blockquote>
        <label>
          Unit Code{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          value={unitData.Code}
          placeholder="Enter Unit Code"
          onChange={(e) => setUnitData({ ...unitData, Code: e.target.value })}
          onInput={(e) =>
            (e.target.value = e.target.value
              .replace(/[^A-Za-z]/g, "")
              .toUpperCase()
              .slice(0, 3))
          }
          required
        />
      </blockquote>

      <blockquote>
        <label>Description</label>
        <textarea
          rows={5}
          placeholder="Enter Description (Upto 400 Characters)"
          value={unitData.Description}
          onChange={(e) =>
            setUnitData({ ...unitData, Description: e.target.value })
          }
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 400);
          }}
        ></textarea>
      </blockquote>
      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddUnitMaster;
